import { visit } from 'unist-util-visit';
import type { Root, Element } from 'hast';

/**
 * Annotate top-level block elements with `data-source-line` (1-based) taken
 * from their mdast/hast position. The preview uses these anchors to map the
 * editor's viewport line to the corresponding rendered element for jitter-free
 * synced scrolling.
 *
 * Runs before sanitize; the sanitize schema explicitly permits
 * `data-source-line` on all elements.
 */
export function rehypeSourceLines() {
  return (tree: Root): void => {
    for (const node of tree.children) {
      if (node.type !== 'element') continue;
      const line = node.position?.start.line;
      if (typeof line === 'number') {
        node.properties = node.properties ?? {};
        (node.properties as Record<string, unknown>)['dataSourceLine'] = line;
      }
    }
    // Also tag headings nested one level down (common in sectioned output),
    // and every task-list item: a checkbox that can be ticked has to know which
    // line of the document it would rewrite.
    visit(tree, 'element', (el: Element) => {
      const isTaskItem =
        el.tagName === 'li' &&
        (Array.isArray(el.properties?.className)
          ? el.properties.className.map(String)
          : []
        ).includes('task-list-item');
      if (
        (/^h[1-6]$/.test(el.tagName) || isTaskItem) &&
        el.position &&
        !el.properties?.['dataSourceLine']
      ) {
        el.properties = el.properties ?? {};
        (el.properties as Record<string, unknown>)['dataSourceLine'] = el.position.start.line;
      }
    });
  };
}
